export default {"src":"/next_webview/_next/static/media/loading.50b65231.gif","height":66,"width":66,"blurWidth":0,"blurHeight":0};